import { Button, Modal, ModalContent, ModalFooter, ModalOverlay } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import ModalHeaderComponent from '../../../../components/ModalHeader';
import { useState } from 'react';
type Props = {
  onClose: () => void;
  updateLessonStatus: (e: any) => void;
};

export default function AgreementLessonModal({ onClose, updateLessonStatus }: Props) {
  const closeModal = () => {
    onClose();
  };
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <>
      <Modal isOpen={true} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeaderComponent title="レッスンを承認しますか？" />
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                setIsSubmitting(true);
                updateLessonStatus({
                  status: 'approved',
                });
              }}
              leftIcon={<CheckIcon />}
              disabled={isSubmitting}
            >
              承認
            </Button>
            <Button colorScheme="red" onClick={closeModal} disabled={isSubmitting}>
              キャンセル
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
